import {yupResolver} from '@hookform/resolvers/yup'
import {enqueueSnackbar} from 'notistack'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {Controller, useForm} from 'react-hook-form'
import Select from 'react-select'
import * as Yup from 'yup'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {BathRoomModel} from '../../../bathrooms/models'
import {createBathRoomService} from '../../../bathrooms/services/createBathRoom.service'
import {MasterModel} from '../../../modules/models'
import {getMasterModuleService} from '../../../modules/services'
import {getRoomByIdService} from '../../services/getRoomById.service'
import {getSnackBarToast} from '../../../../../../util/snackBar'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getBathrooms: () => void
}

const ModalNewBathRoom: FC<Props> = ({show, setShow, getBathrooms}) => {
  const handleClose = () => {
    setShow(false)
  }

  const getSnackBar = (message: string, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const [bathroomType, setBathRoomType] = useState<MasterModel[] | any>([])
  const [genre, setGenre] = useState<MasterModel[] | any>([])
  const {currentTabItem} = useHoteleria()

  const newBathRoomSchema = Yup.object().shape({
    ModuloId: Yup.string().required('Módulo es requerido'),
    TipoBanioId: Yup.string().required('Tipo de Baño es requerido'),
    HabitacionId: Yup.string().required('Habitación es requerido'),
    Codigo: Yup.string().required('Código de Baño es requerido'),
    SexoId: Yup.string().required('Género es requerido'),
    Observaciones: Yup.string().required('Observaciones es requerido'),
  })

  const {
    register,
    setValue,
    handleSubmit,
    // watch,
    control,
    formState: {errors},
  } = useForm<BathRoomModel>({
    resolver: yupResolver(newBathRoomSchema),
  })

  const getBathroomsType = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoBanio',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setBathRoomType(mappedMaster)
    } catch (error) {
      setBathRoomType([])
    }
  }

  const getGenres = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'Sexo',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setGenre(mappedMaster)
    } catch (error) {
      setGenre([])
    }
  }

  const getRoomById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getRoomByIdService(idToEdit as any)
        const {ModuloId, Id} = data
        setValue('ModuloId', ModuloId)
        setValue('HabitacionId', Id)
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (show) {
      getRoomById()
      getBathroomsType()
      getGenres()
    }
  }, [show])

  const onSubmit = async (data: BathRoomModel) => {
    try {
      const {data: res} = await createBathRoomService(data)
      if (!res.error) {
        getSnackBarToast('Se creó con éxito', 'success')

        handleClose()
        getBathrooms()
        setValue('ModuloId', '')
        setValue('SexoId', '')
        setValue('TipoBanioId', '')
        setValue('Codigo', '')
        setValue('Observaciones', '')
        // reiniciar el form
        // mostrar snackbar
      } else {
        getSnackBarToast(res.message, 'error')
      }
    } catch (error) {}

    // handleClose()
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Agregar Baño</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='p-6'>
              <div className='d-flex'>
                <div className='col-6'>
                  <div className='mb-2 col-10'>
                    <label className='required form-label'>Tipo de Baño</label>
                    <div className='input-group input-group-sm'>
                      <Controller
                        control={control}
                        name='TipoBanioId'
                        render={({field}) => (
                          <Select
                            {...field}
                            className='w-100'
                            options={bathroomType}
                            placeholder='Selecciona un tipo de baño'
                            value={bathroomType?.find(
                              (c: {value: string}) => c.value === field.value,
                            )}
                            onChange={(val) => field.onChange(val ? val.value : '')}
                          />
                        )}
                      />
                      <p
                        style={{
                          marginBottom: '0',
                          fontSize: '10px',
                          fontWeight: '600',
                          color: 'red',
                          marginLeft: '5px',
                        }}
                      >
                        {errors.TipoBanioId?.message}
                      </p>
                    </div>
                  </div>
                  <div className='mb-2 col-10'>
                    <label className='required form-label'>Código de Baño</label>
                    <div className='input-group input-group-sm'>
                      <input type='text' className='form-control' {...register('Codigo')} />
                    </div>
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.Codigo?.message}
                    </p>
                  </div>
                </div>
                <div className='col-6'>
                  <div className='mb-2 col-10'>
                    <label className='required form-label'>Género</label>
                    <div className='input-group input-group-sm'>
                      <Controller
                        control={control}
                        name='SexoId'
                        render={({field}) => (
                          <Select
                            {...field}
                            className='w-100'
                            options={genre}
                            placeholder='Selecciona un Genero'
                            value={genre?.find((c: {value: string}) => c.value === field.value)}
                            onChange={(val) => field.onChange(val ? val.value : '')}
                          />
                        )}
                      />
                      <p
                        style={{
                          marginBottom: '0',
                          fontSize: '10px',
                          fontWeight: '600',
                          color: 'red',
                          marginLeft: '5px',
                        }}
                      >
                        {errors.SexoId?.message}
                      </p>
                    </div>
                  </div>
                  <div className='mb-2 col-10'>
                    <label className='required form-label'>Observaciones</label>
                    <div className='input-group input-group-sm'>
                      <input type='text' className='form-control' {...register('Observaciones')} />
                    </div>
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.Observaciones?.message}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                Guardar
              </button>
            </div>
          </form>
          {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
        </div>
      </div>
    </Modal>
  )
}

export {ModalNewBathRoom}
